import type { FaireProductEntity } from "../../entity_types/product";

export const p_9ktrgm5h9u: FaireProductEntity = {
  token: "p_9ktrgm5h9u",
  type: "product",
  name: "Magnesium Mist",
  brandToken: "b_5mmmydek8t",
  brandName: "Ancestral Solskin",
  imageUrl:
    "https://cdn.faire.com/fastly/2cfc2328f5060e1445a681ed2f00b35a104bac8809344cf76f0ffa3183777296.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a63d0d02f63a96aba9d6ded8cf7ec223a833dc7dd519209eabd5e271afbfb7c6.jpeg",
  ],
  priceDollars: 12,
  description:
    "This is a handmade magnesium spray in a 4oz amber glass spray bottle. It's made with 100% pure magnesium chloride.\n\nMagnesium is an essential mineral that enhances cellular regeneration, protects skin from free radical and external damage, reduces skin inflammation, and reduces cortisol and stress. Lavender a natural anti-inflammatory and antibacterial, perfect for calming the skin.",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:20.464Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
